export default "__VITE_ASSET__CZvhSh8p__"